import React, { useEffect, useState } from "react";
import axios from "axios";
import { Phone } from "lucide-react";
import { formatRuPhone, isValidRuPhone, RU_PHONE_PLACEHOLDER } from "../../utils/phone";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// N-7 (TZ-5): контактные данные профиля; телефон попадает в B2B-документы при их формировании
export const ContactDetailsBlock = ({ showToast, onSaved }) => {
  const [current, setCurrent] = useState(null);
  const [editing, setEditing] = useState(false);
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { axios.get(`${API}/profile/contacts`).then((r) => setCurrent(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await axios.put(`${API}/profile/contacts`, { phone });
      setCurrent(r.data); setEditing(false);
      showToast("Телефон сохранён", "success");
      if (onSaved) onSaved();
    } catch (e) {
      showToast(e.response?.data?.detail || "Не удалось сохранить телефон", "error");
    } finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-xl p-5 space-y-3 mb-4" style={{ border: "1px solid var(--rv-border)" }} data-testid="contact-details-block">
      <h3 className="text-base font-semibold flex items-center gap-2" style={{ color: "var(--rv-navy)" }}><Phone size={18} style={{ color: "var(--rv-teal)" }} /> Контактные данные</h3>
      <div className="text-sm space-y-1" style={{ color: "var(--rv-text-secondary)" }}>
        <div>ФИО: <strong data-testid="contact-details-name">{current?.name || "—"}</strong></div>
        <div>Телефон: <strong data-testid="contact-details-phone">{current?.phone_masked || "не указан"}</strong></div>
      </div>
      <p className="text-xs" style={{ color: "var(--rv-text-muted)" }}>Телефон используется для связи и печатается в договоре, счёте и акте ваших B2B-заданий (документы, сформированные после изменения, получат новый номер).</p>
      {editing ? (
        <div className="flex flex-wrap gap-2 items-center">
          <input value={phone} onChange={(e) => setPhone(formatRuPhone(e.target.value))} placeholder={RU_PHONE_PLACEHOLDER} inputMode="tel"
            className="px-3 py-2 rounded-lg text-sm" style={{ border: "1px solid var(--rv-border)" }} data-testid="contact-details-phone-input" />
          <button onClick={save} disabled={saving || !isValidRuPhone(phone)} className="reversia-btn reversia-btn-teal reversia-btn-md" data-testid="contact-details-save-btn">
            {saving ? "Сохранение..." : "Сохранить"}
          </button>
          <button onClick={() => setEditing(false)} className="reversia-btn reversia-btn-md" style={{ border: "1px solid var(--rv-border)" }} data-testid="contact-details-cancel-btn">Отмена</button>
        </div>
      ) : (
        <button onClick={() => { setPhone(formatRuPhone(current?.phone || "")); setEditing(true); }} className="reversia-btn reversia-btn-md" style={{ border: "1px solid var(--rv-border)" }} data-testid="contact-details-edit-btn">
          Изменить телефон
        </button>
      )}
    </div>
  );
};
